/* Chyba z /api/contracts → VŽDY jedna věta (string), nikdy objekt.
 *
 * FastAPI u 422 vrací `detail` jako POLE objektů {loc, msg, type}. Editor
 * smlouvy ho dřív posílal rovnou do toast.error → sonner ho vykreslil jako
 * React child → „Objects are not valid as a React child“ → bílá obrazovka
 * „Něco se nepovedlo“ a poradci zmizelo všechno, co do editoru napsal.
 * Nález ověření 4. 10. 2026: starý backend (před redeployem) nezná typ
 * pojisteni_odpovednost a vrátí právě takovou 422. Stejnou pojistku má
 * e-mail v lib/emailTransport.js (textChyby).
 *
 * Anglické hlášky pydanticu („Input should be …“) poradci nic neřeknou,
 * proto u 422 česká věta ze slovníku; textovou hlášku backendu (400, 404)
 * pouštíme dál beze změny.
 */
import { textJazyka } from "@/lib/i18n/textMimoReact";

/* Známé věty backendu (backend/routes/contracts.py) → klíč slovníku.
 * Backend mluví česky; slovenský nebo vietnamský poradce dřív v toastu
 * četl „Klient nenalezen“ (ověření karty 4. 10. 2026). Čeština dostane
 * větu backendu beze změny, ostatní jazyky překlad. Neznámá věta projde
 * dál beze změny — radši česky než nic. */
export const ZNAME_HLASKY_BACKENDU = Object.freeze({
  "Neplatné id": "neplatneId",
  "Neplatné contact_id": "neplatneId",
  "Kontakt nenalezen": "klientNenalezen",
  "Klient nenalezen": "klientNenalezen",
  "Smlouva nenalezena": "smlouvaNenalezena",
  "Výpověď lze generovat jen pro pojistné smlouvy": "jenPojistne",
});

export function textChybySmlouvy(e, zaloha, lang = "cs") {
  const d = e?.response?.data?.detail;
  if (typeof d === "string" && d.trim()) {
    const klic = ZNAME_HLASKY_BACKENDU[d.trim()];
    return klic && lang !== "cs" ? textJazyka(lang, `smlouvaEditor.chybaServeru.${klic}`, d) : d;
  }
  if (e?.response?.status === 422) {
    return textJazyka(lang, "smlouvaEditor.chybaPoli", "Server údaje nepřijal — zkontrolujte vyplněná pole.");
  }
  return typeof zaloha === "string" ? zaloha : "";
}
